/* AUTO-SYNCED from PsyKit.io/components/bilateral/HapticsStatus.tsx — DO NOT EDIT. Regenerate with `npm run sync`. */
"use client";

import type { HapticsStatus as HapticsStatusType } from "@/lib/haptics/useGamepadHaptics";

interface HapticsStatusBadgeProps {
  status: HapticsStatusType;
  controllerLabel: string | null;
  /** Theme tokens passed in so the badge picks up ControlPanel's active theme. */
  textMuted: string;
  accent: string;
}

/**
 * Compact one-line badge that mirrors the audio-state hint shown next to the
 * "Audio" section heading in ControlPanel.
 */
export default function HapticsStatus({
  status,
  controllerLabel,
  textMuted,
  accent,
}: HapticsStatusBadgeProps) {
  let label: string;
  let useAccent = false;
  switch (status) {
    case "unsupported":
      label = "Browser unsupported (use Chrome/Edge)";
      break;
    case "no-controller":
      label = "Press any button on your controller";
      break;
    case "ready":
      label = controllerLabel ?? "Controller ready";
      useAccent = true;
      break;
  }

  return (
    <span
      className="font-[var(--font-dm-mono)] text-[9px] tracking-normal normal-case"
      style={{ color: useAccent ? accent : textMuted }}
    >
      · {label}
    </span>
  );
}
